<template>
    
    <div class="sidebar">
            
            <b-list-group class="photo_book_page_list_group">

                <b-list-group-item v-for="(url, index) in currentPhotoBookInteriorLayoutImages.images" v-bind:key="url" class="photo_book_page_list_group_item">
                    <photo-book-page-list-item :url="buildUrl(url)" :num="index" @pageselected="pageSelected(index)"></photo-book-page-list-item>
                </b-list-group-item>
               

            </b-list-group>

    </div>

</template>

<script>
import PhotoBookPageListItem from './PhotoBookPageListItem';
import { mapGetters, mapActions, mapState } from 'vuex'
import { Modal, BaseAlert } from '@/components'

export default {
    name: "photo-book-page-list",
    components: {
        Modal,
        BaseAlert,
        PhotoBookPageListItem,
    },
    props: {
        photoBookId: 0,
        token: String,
    },
    data() {
        return {
            loading: false,
            pages: [],
        };
    },


    /*

    this.$store.getters.currentPhotoBookInteriorLayoutImages.forEach((value, index) => {
                        arr.push(value);
                        this.urls.push('http://0.0.0.0:8000'+value);
                        // return 'http://0.0.0.0:8000/'+this.image.image.medium.url; 
                        console.log(value);
                        console.log(index);
                        console.log("the interior images end");
                    });


    **/ 
    methods: {
        buildUrl(url){
            let ht = this.$image_host+url.replace(".png","_s.png");
            return ht
        },
        pageSelected(page){
            console.log("SELECTED page"+page);
            this.$emit('pageselected', page);
        },
        retrievePhotoBookPages() {
            this.loading = true;
            this.$store.dispatch('fetchPhotoBookPages', this.$store.getters.currentPhotoBook.id)
            .then(() => {
                console.log("Getters pages:"+this.$store.getters.currentPhotoBookPages);
                console.log(this.$store.getters.currentPhotoBookPages);
                console.log("State pages:"+this.$store.state.photoBookPages);
            })
            .catch((error) => {
                console.error(error);
                this.loading = true;
            }).finally(() => {
                    this.loading = false;
            });
        },
    },
    computed: {
        ...mapGetters({
            currentAccount: 'currentAccount',
            currentSettings: 'currentSettings',
            currentPhotoBook: 'currentPhotoBook',
            currentPhotoBookPages: 'currentPhotoBookPages',
            currentPhotoBookInteriorLayoutImages: 'currentPhotoBookInteriorLayoutImages',
        }),
        ...mapActions({
            fetchPhotoBookPage: 'fetchPhotoBookPage',
            fetchPhotoBookPages: 'fetchPhotoBookPages',
        }),
        ...mapState({
            photoBookPages: "photoBookPages",
        })
       
    },
    mounted() {
        //console.log(this.photo_book_id);
        console.log("Loading pages from sererv...");
        this.retrievePhotoBookPages();
    },
};
</script>

<style scoped>

.photo_book_page_list{
    margin-right: 10px;
    margin-left: 10px;
}
.photo_book_page_list_group{

}
.photo_book_page_list_group_item{

/*
background-color: #fff;
border: 1px solid #e9ecef;
*/
background-color: rgba(76, 175, 80, 0.0);
border: 0px;
margin: 12px;
padding: 10px;
height: 100px;
}
</style>